import { render, staticRenderFns } from "./teach.vue?vue&type=template&id=224acff8&"
import script from "./teach.vue?vue&type=script&lang=js&"
export * from "./teach.vue?vue&type=script&lang=js&"
import style0 from "./teach.vue?vue&type=style&index=0&id=224acff8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports